import { useEffect, useState } from "react";
import api from "@/lib/api";
import { CalendarCheck, CalendarClock, CreditCard, Euro, Users, Inbox } from "lucide-react";

function Stat({ icon: Icon, label, value }) {
  return (
    <div className="card-dark p-6">
      <div className="flex items-center justify-between">
        <Icon className="text-gold" size={22} />
      </div>
      <div className="font-display font-black text-3xl mt-4">{value}</div>
      <div className="text-sm text-slate-500 mt-1">{label}</div>
    </div>
  );
}

const STATUS_COLOR = {
  CONFIRMED: "text-emerald-400", PENDING_PAYMENT: "text-amber-400", PAYMENT_FAILED: "text-red-400",
  CANCELLED: "text-slate-500", REFUNDED: "text-purple-400", EXPIRED: "text-slate-600",
};

export default function Dashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <div className="text-slate-500">Chargement…</div>;
  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-display font-black text-3xl mb-8">Tableau de bord</h1>
      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-10">
        <Stat icon={CalendarCheck} label="Réservations aujourd'hui" value={d.today_reservations} />
        <Stat icon={CalendarClock} label="À venir" value={d.upcoming_reservations} />
        <Stat icon={CreditCard} label="Paiements" value={d.payments_count} />
        <Stat icon={Euro} label="Chiffre d'affaires" value={`${d.revenue.toFixed(0)} €`} />
        <Stat icon={Users} label="Clients" value={d.clients} />
        <Stat icon={Inbox} label="Demandes en attente" value={d.pending_requests} />
      </div>

      <h2 className="font-display font-bold text-xl mb-4">Dernières réservations</h2>
      <div className="card-dark overflow-hidden">
        {d.recent_reservations.length === 0 ? (
          <div className="p-8 text-center text-slate-500 text-sm">Aucune réservation.</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="text-left text-slate-500 border-b border-white/10">
              <tr><th className="p-4">Numéro</th><th className="p-4">Client</th><th className="p-4">Date</th><th className="p-4">Montant</th><th className="p-4">Statut</th></tr>
            </thead>
            <tbody>
              {d.recent_reservations.map((r) => (
                <tr key={r.id} className="border-b border-white/5">
                  <td className="p-4 font-mono text-gold">{r.booking_number}</td>
                  <td className="p-4">{r.first_name} {r.last_name}</td>
                  <td className="p-4 text-slate-400">{r.date} {r.start_time}</td>
                  <td className="p-4">{r.price_ttc?.toFixed(2)} €</td>
                  <td className={`p-4 font-mono text-xs ${STATUS_COLOR[r.status] || "text-slate-400"}`}>{r.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
